export default "__VITE_ASSET__WvO2ya1H__"